import FooterEmail from "../assets/svgs/footer-email";
import FooterLinkedin from "../assets/svgs/footer-linkedin";


export const Footer = () => {
    return <section className="footer main-layout full">

        <section className="container flex row-revers align-center">
            <section>Powered by Yovel Nehmady </section>
            <div className="social flex align-center">
                <a className="email" target="_blanc" href="mailto:yovelnehmady1998@gmail.com"><FooterEmail /></a>
                <a className="linkedin" target="_blanc" href="https://www.linkedin.com/in/yovel-nehmady/"><FooterLinkedin /></a>
            </div>
        </section>
    </section>;
};